<template>
  <section
    class="client-section pt-navbar pb-5"
    :class="{ 'bg-light': !isDarkMode, 'bg-dark': isDarkMode }"
  >
    <div
      class="client-wrapper"
      :class="{
        'client-wrapper-dark': isDarkMode,
        'client-wrapper-light': !isDarkMode
      }"
    >
      <div class="container">
        <div class="row text-center">
          <div class="col-12 mb-4">
            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns." class="fw-bold">Our Trusted Clients</h3>
          </div>
        </div>

        <div class="row justify-content-center align-items-center gx-3 gy-4">
          <div
            v-for="(logo, index) in logos"
            :key="index"
            class="col-6 col-sm-4 col-md-3 col-lg-2 d-flex justify-content-center"
          >
            <div class="logo-wrapper position-relative text-center">
              <!-- Dgymbook logo with link -->
              <template v-if="captions[index] === 'Dgymbook'">
                <a title="We connect brands with celebrities and influencers for powerful digital campaigns."
                  href="https://play.google.com/store/apps/details?id=com.dgymbook.app"
                  target="_blank"
                  rel="noopener"
                >
                  <img title="We connect brands with celebrities and influencers for powerful digital campaigns."
                    :src="logo"
                    :alt="'Client logo ' + (index + 1)"
                    class="client-logo"
                  />
                </a>
              </template>
              <template v-else>
                <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore"
                  :src="logo"
                  :alt="'Client logo ' + (index + 1)"
                  class="client-logo"
                />
              </template>

              <div class="logo-caption text-truncate">
                {{ captions[index] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ClientLogoGrid",
  data() {
    return {
      isDarkMode: false,
      logos: [
        require("@/assets/logos/clients/c1.jpg"),
        require("@/assets/logos/clients/c2.jpg"),
        require("@/assets/logos/clients/c3.jpg"),
        require("@/assets/logos/clients/c28.jpg"),
        require("@/assets/logos/clients/c4.jpg"),
        require("@/assets/logos/clients/c5.jpg"),
        require("@/assets/logos/clients/c6.jpg"),
        require("@/assets/logos/clients/c7.jpg"),
        require("@/assets/logos/clients/c8.jpg"),
        require("@/assets/logos/clients/c9.jpg"),
        require("@/assets/logos/clients/c10.jpg"),
        require("@/assets/logos/clients/c25.jpg"),
        require("@/assets/logos/clients/c24.jpg"),
        require("@/assets/logos/clients/c11.jpg"),
        require("@/assets/logos/clients/c26.jpg"),
        require("@/assets/logos/clients/c12.jpg"),
        require("@/assets/logos/clients/c13.jpg"),
        require("@/assets/logos/clients/c14.jpg"),
        require("@/assets/logos/clients/c15.jpg"),
        require("@/assets/logos/clients/c16.jpg"),
        require("@/assets/logos/clients/c17.jpg"),
        require("@/assets/logos/clients/c18.jpg"),
        require("@/assets/logos/clients/c19.jpg"),
        require("@/assets/logos/clients/c20.jpg"),
        require("@/assets/logos/clients/c21.jpg"),
        require("@/assets/logos/clients/c22.jpg"),
        require("@/assets/logos/clients/c23.jpg"),
        require("@/assets/logos/clients/c27.jpg"),
        require("@/assets/logos/clients/c29.jpg"),
        require("@/assets/logos/clients/c30.jpg"),
        require("@/assets/logos/clients/littlejoys.jpg"),
        require("@/assets/logos/clients/pearl.jpg"),
        require("@/assets/logos/clients/intra.png"),
      ],
      captions: [
        "Jos Alukkas", "Ramraj", "scott eyewear", "DigiSec Global",
        "Man Matters", "Evolve Back", "InstaPure", "Dgymbook",
        "Casagrand", "Centuary Mattress", "HAP Daily", "Connected Banking",
        "Anupama Hospitals", "Eastern", "Connected Africa", "Hatsun",
        "Ibaco", "Arun Ice Creams", "BodyWise", "Sunpure",
        "Sabai", "Growmow", "Stylive", "E-School",
        "Cublytics", "Parishrama Group", "Shoolin", "ICSA",
        "Thea", "Infiway Global" , "Little joys" ,"Pearl Granexpo" , "Intra Life"
      ]
    };
  },
  mounted() {
    this.isDarkMode = document.body.classList.contains("theme-dark");
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          this.isDarkMode = document.body.classList.contains("theme-dark");
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  },
});
</script>

<style scoped>
.client-section {
  margin-top: 142px;
  padding-bottom: 120px;

}

.client-section h3 {
  font-size: 2.2rem;
  font-weight: 700;
  font-family: "Outfit", sans-serif;
}

.client-wrapper {
  border-radius: 16px;
  padding: 30px 15px;
  transition: background-color 0.4s ease;
   background: linear-gradient(
    180deg,
    #fff 0%,
    rgba(255, 150, 150, 0.27) 0%,
    rgba(255, 150, 150, 0.27) 42.19%,
    rgba(255, 255, 255, 0) 100%
  );
}

.client-wrapper-light {
  background-color: #fff;
}

.client-wrapper-dark {
  background-color: #1e1e1e;
}

.logo-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.client-logo {
  max-width: 100%;
  max-height: 120px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.client-logo:hover {
  transform: scale(1.05);
}

.logo-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px 4px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 500;
  font-family: "Outfit", sans-serif;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.logo-wrapper:hover .logo-caption {
  opacity: 1;
}

.bg-dark {
  background-color: var(--darkBodyBg) !important;
}

/* Dark Mode Styles */
:deep(body.theme-dark) .client-section {
  background-color: var(--darkBodyBg);
}

:deep(body.theme-dark) .client-section h3 {
  color: var(--whiteColor);
}

:deep(body.theme-dark) .logo-caption {
  background: rgba(0, 0, 0, 0.85);
  color: var(--whiteColor);
}

:deep(body.theme-dark) .client-logo {
  filter: brightness(0.9);
}

/* Responsive Typography & Padding */
@media (max-width: 768px) {
  .client-section h3 {
    font-size: 1.8rem;
  }

  .client-wrapper {
    padding: 20px 10px;
  }

  .client-logo {
    max-height: 100px;
  }

  .logo-caption {
    font-size: 0.75rem;
  }
}
</style>
